import * as Types from '../../../../../../../admin/graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type FetchCustomersOptionsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.CustomersFilters>;
  pagination?: Types.InputMaybe<Types.UsersConnectionArgs>;
  order?: Types.InputMaybe<Array<Types.UsersAccountOrmEntityOrderOptions> | Types.UsersAccountOrmEntityOrderOptions>;
}>;


export type FetchCustomersOptionsQuery = { __typename?: 'Query', customers: { __typename?: 'UsersCustomerConnection', edges: Array<{ __typename?: 'UsersCustomerEdge', node: { __typename?: 'Customer', id: string, companyName?: string | null, firstName?: string | null, lastName?: string | null } }>, pageInfo: { __typename?: 'UsersPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type FetchSelectedCustomersOptionsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.CustomersFilters>;
}>;


export type FetchSelectedCustomersOptionsQuery = { __typename?: 'Query', customers: { __typename?: 'UsersCustomerConnection', edges: Array<{ __typename?: 'UsersCustomerEdge', node: { __typename?: 'Customer', id: string, companyName?: string | null, firstName?: string | null, lastName?: string | null } }> } };

export type CustomersOptionFragment = { __typename?: 'Customer', id: string, companyName?: string | null, firstName?: string | null, lastName?: string | null };

export const CustomersOptionFragmentDoc = gql`
    fragment CustomersOption on Customer {
  id
  companyName
  firstName
  lastName
}
    `;
export const FetchCustomersOptionsDocument = gql`
    query FetchCustomersOptions($filters: CustomersFilters, $pagination: UsersConnectionArgs, $order: [UsersAccountOrmEntityOrderOptions!]) {
  customers(filters: $filters, pagination: $pagination, order: $order) {
    edges {
      node {
        ...CustomersOption
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${CustomersOptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchCustomersOptionsGQL extends Apollo.Query<FetchCustomersOptionsQuery, FetchCustomersOptionsQueryVariables> {
    override document = FetchCustomersOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchSelectedCustomersOptionsDocument = gql`
    query FetchSelectedCustomersOptions($filters: CustomersFilters) {
  customers(filters: $filters) {
    edges {
      node {
        ...CustomersOption
      }
    }
  }
}
    ${CustomersOptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchSelectedCustomersOptionsGQL extends Apollo.Query<FetchSelectedCustomersOptionsQuery, FetchSelectedCustomersOptionsQueryVariables> {
    override document = FetchSelectedCustomersOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }